<template>
  <div style="padding: 20px">
    <el-input style="width: 150px" v-model="query.studentName" placeholder="学员名字"></el-input>
    <el-select style="width: 150px" v-model="query.type" placeholder="转化类型" class="handle-select mr10">
      <el-option label="正价转化引流" :value="1"></el-option>
      <el-option label="引流转化正价" :value="2"></el-option>
    </el-select>
    <select-area @areaListId="getAreaListId"/>
    <el-date-picker
        v-model="query.yearAndMonth"
        type="month"
        style="width: 170px;"
        value-format="YYYY-MM"
        placeholder="日期选择">
    </el-date-picker>
    <el-button
        type="primary"
        icon="Search"
        style="margin-left: 10px"
        @click="selectList">搜索
    </el-button>

    <el-button v-permission="['drainage:export']"
        type="primary"
        style="margin-left: 10px"
        @click="exportTrainee">导出
    </el-button>
    <div>
      <el-table :data="tableData" border style="width: 100%;margin-top: 20px"
                :row-style="{height:54+'px'}"
                :cell-style="{padding:0+'px'}">
        <el-table-column prop="oid" label="订单ID" width="100"/>
        <el-table-column prop="stuName" label="学员名字" width="140"/>
        <el-table-column prop="coachName" label="提交人" width="140"/>
        <el-table-column prop="areaName" show-overflow-tooltip label="校区" width="180"/>
        <el-table-column prop="city" label="城市" width="110"/>
        <el-table-column prop="areaFlag" label="城市类型" width="100"/>
        <el-table-column prop="collectionTime" label="收款时间" width="100"/>
        <el-table-column prop="ctype" label="类型" width="80"/>
        <el-table-column prop="money" label="缴费金额" width="100"/>
        <el-table-column prop="afterOId" label="转化订单ID" width="120"/>
        <el-table-column prop="afterCoachName" label="转化提交人" width="100"/>
        <el-table-column prop="afterCollectionTime" label="转化收款时间" width="140"/>
        <el-table-column prop="afterCType" label="转化类型" width="100"/>
        <el-table-column prop="afterMoney" label="转化缴费金额" width="140"/>
      </el-table>
      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :total="query.total"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>

    </div>

  </div>
</template>

<script>

import {exportOrderDivert, selectOrderDivertPage} from "../../api/studentList";
import SelectArea from "../../components/SelectArea";

export default {
  name: "Drainage",
  components: {SelectArea},
  data() {
    return {
      query: {
        areaIdList: [],
        month: null,
        pageIndex: 1,
        pageSize: 10,
        studentName: "",
        yearAndMonth: null,
        type: null,
        year: null,
        total: 0
      },
      tableData: [],
      regionList: [],
    }
  },
  created() {
    this.selectList();
  },
  methods: {
    dateFormat(val) {
      const date = new Date(val);
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      return [y, m];
    },
    handlePageChange(val) {
      this.query.pageIndex = val
      this.selectList();
    },
    //加载数据
    selectList() {
      if (this.query.yearAndMonth) {
        let list = this.dateFormat(this.query.yearAndMonth);
        this.query.year = list[0];
        this.query.month = list[1];
      } else {
        this.query.year = null;
        this.query.month = null;
      }
      selectOrderDivertPage(this.query).then(val => {
        if (val.code == 200) {
          this.tableData = val.data.records;
          this.query.total = val.data.total
        } else {
          this.$message.error("获取列表失败！");
        }
      })
    },
    //导出
    exportTrainee() {
      if (this.query.yearAndMonth) {
        let list = this.dateFormat(this.query.yearAndMonth);
        this.query.year = list[0];
        this.query.month = list[1];
      } else {
        this.query.year = null;
        this.query.month = null;
      }
      exportOrderDivert(this.query).then(val => {
        if (val.code == 200) {
          this.$message.success("导出中，右上角可查看进度！")
        } else {
          this.$message.error(val.message);
        }
      })
    },
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
  },

}
</script>

<style scoped>

</style>
